import React from "react";
import styled from "styled-components";
import { device } from "../device";

const isGenerator = window.location.href.includes("create_unit_form");
function ScaleComp(props) {
  const {
    scaledPreDesktop,
    scaledLaptopM,
    scaledTablet,
    scaledMobile,
    isSmall,
    children,
  } = props;

  const originalRef = React.useRef();

  const [orginalSizes, setOrginalSizes] = React.useState({
    width: 0,
    height: 0,
  });

  const scaling = {
    mobileS: scaledMobile,
    tablet: scaledTablet,
    laptopM: scaledLaptopM,
    preDesktop: scaledPreDesktop,
  };

  React.useEffect(() => {
    // the original size of the element
    let firstCheck = true;
    if (originalRef.current !== undefined && firstCheck) {
      const originalWidth = originalRef.current.clientWidth;
      const originalHeight = originalRef.current.clientHeight;

      setOrginalSizes({ width: originalWidth, height: originalHeight });
      firstCheck = false;
    }
  }, [originalRef]);

  return (
    <NormalizedTheScale
      orginalSizes={orginalSizes}
      scale={scaling}
      isSmall={isSmall}
    >
      <ScaledComponent scale={scaling} setOrginalSizes={setOrginalSizes}>
        <div ref={originalRef}>{children}</div>
      </ScaledComponent>
    </NormalizedTheScale>
  );
}

export default ScaleComp;

const NormalizedTheScale = styled.div`
  // border: 1px solid gold;
  overflow: hidden;
  @media ${device.mobileS} {
    width: ${(props) =>
      props.isSmall ? 400 * props.scale.mobileS : 525 * props.scale.mobileS}px;
    height: ${(props) => 354 * props.scale.mobileS}px;
  }
  @media ${device.tablet} {
    width: ${(props) =>
      props.isSmall ? 400 * props.scale.tablet : 525 * props.scale.tablet}px;
    height: ${(props) => 354 * props.scale.tablet}px;
  }
  @media ${device.laptopM} {
    width: ${(props) =>
      !isGenerator &&
      (props.isSmall
        ? 400 * props.scale.laptopM
        : 525 * props.scale.laptopM)}px;
    height: ${(props) => !isGenerator && 354 * props.scale.laptopM}px;
  }
  @media ${device.preDesktop} {
    width: ${(props) =>
      !isGenerator &&
      (props.isSmall
        ? 400 * props.scale.preDesktop
        : 525 * props.scale.preDesktop)}px;
    height: ${(props) => !isGenerator && 354 * props.scale.preDesktop}px;
  }
`;

const ScaledComponent = styled.div`
  // border: 1px solid red;
  transform-origin: left top;
  @media ${device.mobileS} {
    transform: scale(${(props) => props.scale.mobileS});
  }
  @media ${device.tablet} {
    transform: scale(${(props) => props.scale.tablet});
  }
  @media ${device.laptopM} {
    transform: scale(${(props) => !isGenerator && props.scale.laptopM});
  }
  @media ${device.preDesktop} {
    transform: scale(${(props) => !isGenerator && props.scale.preDesktop});
  }
`;
